import { useState } from "react";
import FileViewer from "./FileViewer";

/**
 * 
 * @param {object} props 
 * @param {Array<{name: String, url: String}>} props.attachments
 * @param {"grid"|"list"} props.variant
 * @param {string} props.className
 */
export default function AttachmentList(props) {

   const { attachments, variant, className } = props;

   const [ fileViewerUrl, setFileViewerUrl ] = useState(null);

   const attachmentList = attachments.map(attachment => (
      <div
         key={attachment.url}
         className="text-blue-500 underline cursor-pointer truncate"
         onClick={() => setFileViewerUrl(attachment.url)}
      >
         {attachment.name}
      </div>
   ));

   const layoutClassess = variant === 'grid' ? 'grid grid-cols-1  sm:grid-cols-2' : 'flex flex-col';

   return <div className={`${className} ${layoutClassess} gap-4`}>
      {attachmentList}
      {
         fileViewerUrl && <FileViewer
            url={fileViewerUrl}
            onClose={() => setFileViewerUrl(null)}
         />
      }
   </div>


}